package com.mps.asc_app.data.user

enum class TrainingGroupType {
    TEAM,
    YEAR,
}

data class TrainingGroup(
    val id: String,
    val name: String,
    val type: TrainingGroupType,
)

